import { useStore } from "@/stores";
import type { TranslateFunction } from "@/shared/i18n/translations";

/**
 * Hook to access the current locale's translation function
 * Refactored to use MobX UiStore
 */
export const useTranslation = (): TranslateFunction => {
  const { uiStore } = useStore();
  return uiStore.t;
};
